import { buildLoginHrefWithNext, sanitizeNextPath } from './authRedirectPath';

/** Canonical public calculator path; used for post-auth return from CTAs. */
export const PUBLIC_UVALUE_CALCULATOR_PATH = '/u-value/calculator';

export function buildPublicUValueCalculatorLoginHref(): string {
  return buildLoginHrefWithNext(PUBLIC_UVALUE_CALCULATOR_PATH);
}

export function buildPublicUValueCalculatorRegisterHref(): string {
  return `/auth/register?next=${encodeURIComponent(PUBLIC_UVALUE_CALCULATOR_PATH)}`;
}

export { buildLoginHrefWithNext } from './authRedirectPath';

export function buildRegisterSuccessHref(nextPath?: string | null): string {
  if (nextPath == null || nextPath.trim() === '') return '/auth/register-success';
  const safe = sanitizeNextPath(nextPath, PUBLIC_UVALUE_CALCULATOR_PATH);
  return `/auth/register-success?next=${encodeURIComponent(safe)}`;
}
